export default "__VITE_ASSET__YlL_bVvk__"